import { render, staticRenderFns } from "./CreateEditTurmaModal.vue?vue&type=template&id=394adc6f&"
import script from "./CreateEditTurmaModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditTurmaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports